import React, { useState } from 'react';
import Calificador from './calificador';
import sergio from '../../Assets/Images/sergio.jpeg';
import manuel from '../../Assets/Images/manuel.jpeg';
import jorge from '../../Assets/Images/jorge.jpeg';
import ramon from '../../Assets/Images/ramon.jpeg';
import './empleados.css';

const empleadosData = [
  { id: 1, nombre: 'Manuel', foto: manuel },
  { id: 2, nombre: 'Jorge', foto: jorge },
  { id: 3, nombre: 'Sergio', foto: sergio },
  { id: 4, nombre: 'Ramón', foto: ramon }
];

const EmpleadosList = () => {
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);

  if (empleadoSeleccionado) {
    return (
      <Calificador
        empleado={empleadoSeleccionado}
        volver={() => setEmpleadoSeleccionado(null)}
      />
    );
  }

  return (
    <main className="rating-page">
      <section className="rating-shell" aria-labelledby="rating-title">
        <header className="rating-header">
       {/*    <p className="rating-brand">Estación de Carnes</p> */}
          <span className="rating-divider" aria-hidden="true" />
          <h1 id="rating-title">Queremos conocer tu experiencia</h1>
          <p>
            Gracias por elegirnos. Te pedimos unos minutos para calificar nuestra
            atención y ayudarnos a mejorar.
          </p>
        </header>

        <div className="employee-section">
          <h2>¿Quién te atendió?</h2>
          <p className="employee-help">Tocá la foto del vendedor para continuar.</p>

          <div className="employee-grid">
            {empleadosData.map((empleado) => (
              <button
                type="button"
                className="employee-card"
                key={empleado.id}
                onClick={() => setEmpleadoSeleccionado(empleado)}
                aria-label={`Calificar la atención de ${empleado.nombre}`}
              >
                <img src={empleado.foto} alt="" />
                <span>{empleado.nombre}</span>
              </button>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default EmpleadosList;
